import { style } from '@vanilla-extract/css';

export const resultsContainer = style({
  padding: 'var(--wt-padding) var(--wt-padding) 0',
});

export const resultsHeader = style({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginBottom: '0.5rem',
  fontSize: 'var(--wt-paragraph-font-size)',
  fontFamily: 'var(--wt-paragraph-font-family)',
  lineHeight: 'var(--wt-paragraph-line-height)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, inherit))',
});

export const resultsList = style({
  padding: 0,
  margin: 0,
  listStyleType: 'none',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
});

export const resultsListBullet = style({
  listStyleType: 'disc',
  marginLeft: '1.5rem',
});

export const resultsListNumbered = style({
  listStyleType: 'decimal',
  marginLeft: '1.5rem',
});

export const resultsListInline = style({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '0.25rem',
  alignItems: 'center',
});

export const resultItem = style({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  borderRadius: '0.25rem',
  border: '1px solid rgba(128, 128, 128, 0.2)',
  padding: '0.5rem 1rem',
  fontFamily: 'var(--wt-paragraph-font-family)',
  fontSize: 'var(--wt-paragraph-font-size)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, inherit))',
});

export const resultItemSelected = style({
  fontWeight: 600,
});

export const resultItemUnselected = style({
  opacity: 0.65,
});

export const resultItemCorrect = style({
  backgroundColor: 'rgba(34, 197, 94, 0.15)',
});

export const resultItemIncorrect = style({
  backgroundColor: 'rgba(239, 68, 68, 0.15)',
});

export const resultItemVoting = style({
  backgroundColor: 'rgba(128, 128, 128, 0.08)',
});

export const resultLabel = style({
  position: 'relative',
  zIndex: 1,
});

export const resultPercentage = style({
  marginLeft: '0.5rem',
  fontSize: '0.75rem',
  opacity: 0.75,
  position: 'relative',
  zIndex: 1,
});

export const resultIcon = style({
  marginLeft: 'auto',
  position: 'relative',
  zIndex: 1,
  flexShrink: 0,
});

export const progressBar = style({
  position: 'absolute',
  bottom: 0,
  left: 0,
  height: '3px',
  width: '100%',
  backgroundColor: 'rgba(128, 128, 128, 0.15)',
  borderBottomLeftRadius: '0.25rem',
  borderBottomRightRadius: '0.25rem',
});

export const progressFill = style({
  height: '100%',
  transition: 'width 0.5s ease-out',
});

export const progressFillDefault = style({
  backgroundColor: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, #666))',
  opacity: 0.4,
});

export const progressFillCorrect = style({
  backgroundColor: 'rgb(34, 197, 94)',
});

export const progressFillIncorrect = style({
  backgroundColor: 'rgb(239, 68, 68)',
});

export const listResultItem = style({
  position: 'relative',
  padding: '0.25rem 0',
  fontFamily: 'var(--wt-list-font-family, var(--wt-paragraph-font-family))',
  fontSize: 'var(--wt-list-font-size, var(--wt-paragraph-font-size))',
  lineHeight: 'var(--wt-list-line-height, var(--wt-paragraph-line-height))',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, inherit))',
});

export const inlineResultItem = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.25rem',
  fontFamily: 'var(--wt-paragraph-font-family)',
  fontSize: 'var(--wt-paragraph-font-size)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, inherit))',
});

export const inlineSeparator = style({
  padding: '0 0.25rem',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, inherit))',
});

export const feedbackLink = style({
  display: 'inline-block',
  marginTop: '0.35rem',
  fontSize: '0.7rem',
  fontFamily: 'var(--wt-paragraph-font-family)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, inherit))',
  opacity: 0.4,
  textDecoration: 'none',
  transition: 'opacity 0.15s',
  ':hover': {
    opacity: 0.65,
  },
});

export const redirectLink = style({
  display: 'inline-block',
  marginTop: '0.75rem',
  fontSize: 'var(--wt-paragraph-font-size)',
  fontFamily: 'var(--wt-paragraph-font-family)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, inherit))',
  textDecoration: 'underline',
});
